import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { AreaAdmin } from '../../models/area'
import { ConversaAreaPage } from '../../pages/conversa-area/conversa-area';
import { NavController } from 'ionic-angular';
import { AtalhoConversa } from '../shared/abstract/atalho-conversa';
import { BrComDao } from '../../service/BrComDao';
import { FotoProvider } from '../../providers/foto/foto';
import { ListaConversaUsuarioPage } from '../../pages/lista-conversa-usuario/lista-conversa-usuario';

@Component({
  selector: 'conversa-area-admin',
  templateUrl: 'conversa-area-admin.html'
})
export class ConversaAreaAdminComponent  extends AtalhoConversa {

  @Input() areaAdmin: AreaAdmin;
  @Output() quantidadeMensagensNaoLidas: EventEmitter<number>;
  private idUsuario: number;
  public isAdmin: boolean;

  constructor(private navCtrl: NavController, private brComDAO: BrComDao, private fotoProvider: FotoProvider) {
    super();
    this.idUsuario = this.brComDAO.getEmpresa().IdUsuario;
    this.quantidadeMensagensNaoLidas = new EventEmitter<number>();
  }

  ngOnInit() {
    this.atualizarNumMensagensNaoLidas();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.atualizarNumMensagensNaoLidas();
  }

  protected atualizarNumMensagensNaoLidas(): void {
    this._quantidadeMensagensNaoLidas = 0;
   /* for(const c of this.areaAdmin.conversasUsuarios) {
      if (c.mensagens) {
        this._quantidadeMensagensNaoLidas += c.mensagens.filter(m => m.origem === "L"
        && !m.statusMensagemLida).length;
      }
    } */
    this._quantidadeMensagensNaoLidas += this.areaAdmin.mensagensGerais.filter(m => m.origem === "L"
    && !m.statusMensagemLida).length
    this.quantidadeMensagensNaoLidas.emit(this._quantidadeMensagensNaoLidas);
  }

  public abrirConversa(): void {
    this.navCtrl.push(ListaConversaUsuarioPage, {
      areaAdmin: this.areaAdmin
    })
  };

  public isUsuarioAdmin(): boolean {
    const idAdmins = this.areaAdmin.idAdministradores || [];
    for (const idAdmin of idAdmins) {
      if (idAdmin === this.idUsuario) {
        return true;
      }
    }
    return false;
  }

  public getFotoPerfil(): string {
    if (this.areaAdmin.hashImagem === "" || !this.areaAdmin.hashImagem) {
      return "assets/img/usuario.png";
    }
    return this.fotoProvider.getUrlImagemServidor(this.areaAdmin.hashImagem);
  }

}



// WEBPACK FOOTER //
// ./src/components/conversa-area-admin/conversa-area-admin.ts